/* global io */

/**
 * Devuelve «protocolo://host:puerto» a partir de la URL del manifest.
 */
export function getSocketBaseUrl(manifestUrl) {
  const u = new URL(manifestUrl);
  return `${u.protocol}//${u.hostname}${u.port ? ':' + u.port : ''}`;
}

/**
 * Comprueba si:
 *   1. El manifest responde (HEAD 2xx)
 *   2. El socket (origin del manifest) acepta conexión
 *
 * Devuelve `true` si ambos pasos van bien, `false` en cualquier otro caso.
 */
export async function checkWebRTCAvailability(manifestUrl) {
  if (!manifestUrl) return false;

  /* 1️⃣  HEAD al manifest -------------------------------------- */
  try {
    const r = await fetch(manifestUrl, { method: 'HEAD', mode: 'cors' });
    if (!r.ok) return false;
  } catch {
    return false;
  }

  /* 2️⃣  Test rápido de socket --------------------------------- */
  const baseUrl = getSocketBaseUrl(manifestUrl);

  return await new Promise(resolve => {
    let settled = false;
    const done = ok => {
      if (!settled) {
        settled = true;
        socket.close();
        resolve(ok);
      }
    };

    const socket = io(baseUrl, { transports: ['websocket'], timeout: 1500 });

    socket.on('connect',       () => done(true));
    socket.on('connect_error', () => done(false));
    socket.on('error',         () => done(false));

    setTimeout(() => done(false), 1500);
  });
}

/**
 * Muestra en consola los tracks activos (debug).
 */
export function debugTracks(renderStream) {
  console.log(
    '[MS-Player] 🔍 tracks:',
    renderStream.getVideoTracks().map(t => `${t.label}(${t.readyState})`),
    renderStream.getAudioTracks().map(t => `${t.label}(${t.readyState})`)
  );
}

/**
 * Monitorea la llegada de frames de vídeo mediante requestVideoFrameCallback.
 */
export function monitorFrames(videoElement) {
  const track = videoElement?.srcObject?.getVideoTracks()[0];
  if (!track || !videoElement?.requestVideoFrameCallback) return;
  const loop = () => {
    videoElement.requestVideoFrameCallback((_, m) => {
      console.log('[MS-Player] 🎞️ Video frame', m);
      loop();
    });
  };
  loop();
}

/**
 * Intenta hacer play en el videoElement, con fallback de alerta si falla.
 */
export function forcePlay(videoElement) {
  return videoElement.play().catch(() => alert('Toca el vídeo para reproducir'));
}

/**
 * Cambia la pista activa de WebRTC (mediasoup).
 */
export function msSwitchTrack(kind, trackId, allConsumers, renderStream, socket, currentTrack) {
  for (const [id, consumer] of Object.entries(allConsumers[kind] || {})) {
    if (id === trackId) {
      consumer.resume();
      if (!renderStream.getTracks().includes(consumer.track))
        renderStream.addTrack(consumer.track);
      currentTrack[kind] = consumer;
    } else {
      consumer.pause();
      renderStream.removeTrack(consumer.track);
    }
  }
  socket.emit('switchTrack', { kind, trackId });
}